var React = require('react');

function Grid24Inline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2 2H11V11H2V2ZM4 4H9V9H4V4ZM2 13H11V22H2V13ZM4 15H9V20H4V15ZM22 2H13V11H22V2ZM20 4H15V9H20V4ZM13 13H22V22H13V13ZM15 15H20V20H15V15Z","fill":"black"}));
}

Grid24Inline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Grid24Inline;

Grid24Inline.default = Grid24Inline;
